/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Reasons a segment may be rejected during server-side validation.
 */
export type SegmentErrorReason = typeof SegmentErrorReason[keyof typeof SegmentErrorReason];


export const SegmentErrorReason = {
  invalid_progression_range: 'invalid_progression_range',
  invalid_segment_order: 'invalid_segment_order',
  segment_too_long: 'segment_too_long',
  invalid_timestamp: 'invalid_timestamp',
  unknown_product: 'unknown_product',
} as const;
